/** */
import {
  ADD_MANY_USERS_TO_STORE,
  ADD_ONE_USER_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_USERS_TO_STORE,
  REM_ONE_USER_FROM_STORE
} from '../actions/user';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_USERS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (users, user) => ({
            ...users,
            [user.id]: user
          }),
          {}
        )
      };
    case ADD_ONE_USER_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (users, user) => ({
            ...users,
            [user.id]: user
          }),
          {}
        )
      };
    case LOAD_USERS_TO_STORE:
      return {
        ...payload.reduce(
          (users, user) => ({
            ...users,
            [user.id]: user
          }),
          {}
        )
      };
    case REM_ONE_USER_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
